module.exports = __webpack_public_path__ + "img/loan.2c637a3b.svg";